import { createContext } from "react";
const TextContext = createContext(null);
export {
  TextContext
};
